import React from 'react';
import './header.css';
import people from '../../assets/people.png'
import ai from '../../assets/ai.png'

const Header = () => {
    return (
        <div className='gpt3__header section__padding' id='home'>
            <div className='gpt3__header-content'>
                <h1 className='gradient__text'>Let's build something amazing with GTP-3 OpenAI</h1>

                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Soluta, facilis ex ipsa similique quo sequi est, aliquid dolores non, facere architecto officia alias reprehenderit minima quibusdam deleniti. Architecto, est rerum!</p>

                <div className='gpt3__header-content__input'>
                    <input type="email" placeholder="your email adress"/>
                    <button type="button">Get started</button>
                </div>

                <div className='gpt3__header-content__people'>
                    <img src={people} alt='people' />

                    <p>1.700 people requested access a visit in last than 24 hours</p>
                </div>
            </div>
                <div className='gpt3__header-image'>
                        <img src={ai} alt='ai' />
                </div>
        </div>
    )
}

export default Header
